export function formatPhoneNumber(phoneNumber: string) {
	const phone = phoneNumber.replace(/[^\d]/g, '').slice(1);

	if (phone.length === 10) {
		return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	}

	return null;
}
